// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = 'vote/2021project/q4/2021finance/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

const getVoteList = (workType: string, page: number, search: string) => {
  return http.get(`${urlPrefix}vote-list`, {
    params: {
      workType,
      page,
      search,
    },
  });
};

const getDetail = (id: string) => {
  return http.get(`${urlPrefix}detail`, {
    params: {
      id,
    },
  });
};

const getRules = () => {
  return http.get(`${urlPrefix}rules`);
};

const getPrize = (data: {
  unionid?: any;
  udid?: any;
  appkey?: any;
  token?: string;
}) => {
  const qsData = qs.stringify(data);
  return http.post(`${urlPrefix}luck_draw_num`, qsData);
};

const getRes = (data: {
  unionid?: any;
  udid?: any;
  appkey?: any;
  token?: string;
}) => {
  const qsData = qs.stringify(data);
  return http.post(`${urlPrefix}luck_draw`, qsData);
};

const getMess = (data: {
  unionid?: any;
  udid?: any;
  appkey?: any;
  token?: string;
  name?: any;
  phone?: any;
}) => {
  const qsData = qs.stringify(data);
  return http.post(`${urlPrefix}save_message`, qsData);
};

const ifMess = (data: {
  unionid?: any;
  udid?: any;
  appkey?: any;
  token?: string;
}) => {
  const qsData = qs.stringify(data);
  return http.post(`${urlPrefix}if-message`, qsData);
};

const getAddr = (data: {
  unionid?: any;
  udid?: any;
  appkey?: any;
  token?: string;
}) => {
  const qsData = qs.stringify(data);
  return http.post(`${urlPrefix}message`, qsData);
};

const userPrize = (data: {
  unionid?: any;
  udid?: any;
  appkey?: any;
  token?: string;
}) => {
  const qsData = qs.stringify(data);
  return http.post(`${urlPrefix}userPrize`, qsData);
};
export {
  getBaseInfo,
  getVoteList,
  getDetail,
  getRules,
  getPrize,
  getRes,
  getMess,
  ifMess,
  getAddr,
  userPrize,
};
